import { DatabaseModel } from './database-model';

export class ChallengeStateMap {
    // Challenge list
    public states: { [challengeKey: string]: ChallengeState };

    constructor(json) {
        this.fromJson(json);
    }

    /**
     * Get the state object with current points and point map of a challenge
     */
    public getChallengeState(challengeKey: string): ChallengeState {
        if(this.states && this.states[challengeKey]) return this.states[challengeKey];
        // Return new if state doesn't exist yet
        return new ChallengeState({});
    }

    /**
     * Get users current level in a given challenge / quest
     */
    public getChallengeLevel(challengeKey: string): number {
        if(this.states && this.states[challengeKey]) return this.states[challengeKey].level;
        // Return level one if challenge state does not exist yet
        return 0;
    }

    /**
     * Get number of points given for answering a question (0 if not answered yet)
     */
    public getQuestionPoints(challengeKey: string, moteKey: string): number {
        let state = this.getChallengeState(challengeKey);
        let points = (state && state.pointMap) ? state.pointMap[moteKey] : 0;
        return points || 0;
    }

    /**
     * Indicate if the user answered a question correctly already
     */
    public isAnsweredCorrectly(challengeKey: string, moteKey: string): boolean {
        let state = this.getChallengeState(challengeKey);
        let correct = (state && state.correctAnswersMap && state.correctAnswersMap[moteKey]);
        return correct;
    }

    public toJson() {
        return Object.keys(this.states).reduce((acc, key) => {
            let state = this.states[key];
            acc[state.challenge] = state.toJson();
            return acc;
        }, {});
    }

    public fromJson(json: any): ChallengeStateMap {
        this.states = Object.keys(json).reduce((acc, key) => {
            let stateJson = json[key];
            acc[stateJson.challenge] = new ChallengeState(stateJson);
            return acc;
        }, {});
        return this;
    }
}

export class ChallengeState extends DatabaseModel {
    // Unused key
    public key: string = '';
    // Challenge key reference
    public challenge: string = '';
    // Sum of 'normal' quiz points awarded in challenge
    public points: number = 0;
    // Sum of bonus points given in challenge
    public bonusPoints: number = 0;
    // Challenge / quest level which reflects the stage/level the user has reached in the challenge
    public level: number = 0;
    // Map of points given with moteKey or questionKey as index 
    public pointMap: { [questionKey: string]: number } = {};
    // Map of correct answers given with moteKey or questionKey as index 
    public correctAnswersMap: { [questionKey: string]: boolean } = {};

    constructor(json: any) {
        super();
        this.fromJson(json);
    }

    public getTotalPoints() {
        // Bonus points are included in points
        return this.points;
    }

    public toJson() {
        return {
            challenge: this.challenge,
            points: this.points,
            bonusPoints: this.bonusPoints,
            level: this.level,
            pointMap: this.pointMap,
            correctAnswersMap: this.correctAnswersMap
        }
    }

    public fromJson(json: any): ChallengeState {
        this.challenge = json.challenge || '';
        this.points = json.points || 0;
        this.bonusPoints = json.bonusPoints || 0;
        this.level = json.level || 0;
        this.pointMap = json.pointMap || {};
        this.correctAnswersMap = json.correctAnswersMap || {};
        return this;
    }
}
